import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { formatStatus, getColorFromStatusLabel } from "../../redux/intervention/interventionStatusActions";
import TableWithoutPagination from "../Table/TableWithoutPagination";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import "./WorkOrderCard.css";
import SynchroteamIcon from "../../images/synchroteam_icon.png";
import IconButton from "@mui/material/IconButton";
import moment from "moment";
import CustomizedTextField from "../Input/CustomizedTextField";
import InterventionStatusIcon from "./InterventionStatusIcon";

class WorkOrderCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			partsColumns: [
				{
					Id: "parts-" + this.props.currentWorkOrder.id,
					Header: "Sorties de pièces",
					Cell: ({ row }) => {
						let currentDetail = this.props.currentWorkOrder.parts[row.index];

						if (!currentDetail) return null;

						return (
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-ellipsis">
										<span>Description</span>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding long-text-value">
										<span>{currentDetail.description}</span>
									</div>
								</div>
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-ellipsis">
										<span>{"Quantité"}</span>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding long-text-value">
										<span>{currentDetail.quantity}</span>
									</div>
								</div>
							</div>
						);
					},
				},
			],
			columns: [
				{
					Id: "details-" + this.props.currentWorkOrder.id,
					Header: "Détails",
					Cell: ({ row }) => {
						let currentDetail = this.props.currentWorkOrder.lines[row.index];

						if (!currentDetail) return null;

						return (
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
								{currentDetail.has_liquid_file ? (
									<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-ellipsis">
											<span>Fiche fluide</span>
										</div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding">
											<Checkbox
												checked={currentDetail.has_liquid_file}
												className="small-checkbox"
											/>
										</div>
									</div>
								) : (
									<div></div>
								)}
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-ellipsis">
										<span>Equipement</span>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding long-text-value">
										<span>{currentDetail.equipment_description}</span>
									</div>
								</div>
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-ellipsis">
										<span>Panne</span>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding long-text-value">
										<span>{currentDetail.failure_description}</span>
									</div>
								</div>
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-ellipsis">
										<span>{"Motifs d'intervention"}</span>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding long-text-value">
										<span>{currentDetail.intervention_reason_ids}</span>
									</div>
								</div>
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding label-ellipsis">
										<span>Rapport</span>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-padding long-text-value">
										<span>{currentDetail.report_line_detail}</span>
									</div>
								</div>
							</div>
						);
					},
				},
			],
		};
	}

	openSynchroTeamLink() {
		var win = window.open(this.props.currentWorkOrder.synchroteam_url, "_blank");
		win.focus();
	}

	render() {
		let synchroteamIconElement = <div></div>;
		if (this.props.currentWorkOrder.synchroteam_url) {
			synchroteamIconElement = (
				<IconButton className="btn-grey-shadow" onClick={this.openSynchroTeamLink.bind(this)}>
					<img src={SynchroteamIcon} alt="Synchroteam" width="32px" height="32px" />
				</IconButton>
			);
		}

		return (
			<div className="col-lg-4 col-md-6 col-sm-12 col-12">
				<Card className="card without-padding card-margin-top">
					<CardHeader
						style={{ color: "rgb(117, 117, 117)" }}
						title={"OT " + this.props.currentWorkOrder.name}
						action={synchroteamIconElement}
						className="card-header-padding-bottom"
					/>

					<CardContent className="without-padding card-content-left-align">
						<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
							<CustomizedTextField
								id={"date" + this.props.currentWorkOrder.name}
								className="full_size light-disabled"
								value={moment(this.props.currentWorkOrder.date_planned_start).format(
									"DD/MM/YYYY HH:mm"
								)}
							/>
						</div>
						<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
							<CustomizedTextField
								id={"technicians" + this.props.currentWorkOrder.name}
								className="full_size light-disabled"
								value={this.props.currentWorkOrder.technicians}
							/>
						</div>
						<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
							<CustomizedTextField
								id={"type" + this.props.currentWorkOrder.name}
								className="full_size light-disabled"
								value={this.props.currentWorkOrder.allocation_label}
							/>
						</div>
						<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
							<div className="span-center bold">
								<div className="row">
									<InterventionStatusIcon className="without-side-padding col-lg-3 col-md-3 col-sm-3 col-3" state={this.props.currentWorkOrder.state} />
									<span
										className={
											" col-lg-9 col-md-9 col-sm-9 col-9 status-icon-color-" +
											getColorFromStatusLabel(this.props.currentWorkOrder.state)
										}
									>
										{formatStatus(this.props.currentWorkOrder.state)}
									</span>
								</div>
							</div>
						</div>
						{this.props.currentWorkOrder.has_liquid_file ? (
							<Typography className="red-text fluid-file-btn">{"Fiche fluide"}</Typography>
						) : (
							<div></div>
						)}
						<Accordion>
							<AccordionSummary
								className="without-side-padding control-margin-top"
								expandIcon={<ExpandMoreIcon />}
							>
								<Typography className="expandable-div-work-order span-center">
									Voir en détail
								</Typography>
							</AccordionSummary>
							<AccordionDetails className="without-padding">
								<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding">
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
										<CustomizedTextField
											id={"report_overview" + this.props.currentWorkOrder.name}
											label={"Rapport"}
											className="full_size light-disabled"
											value={this.props.currentWorkOrder.report_overview}
										/>
									</div>
                                    {!this.props.isExtranetApp ? (
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
										<CustomizedTextField
											id={"internal-comment" + this.props.currentWorkOrder.name}
											label={"Commentaire interne"}
											className="full_size light-disabled"
											value={this.props.currentWorkOrder.internal_comment}
										/>
									</div>

                                    ) : null}
									<TableWithoutPagination
										minRows={5}
										data={this.props.currentWorkOrder.lines}
										columns={this.state.columns}
									/>
									<TableWithoutPagination
										minRows={5}
										data={this.props.currentWorkOrder.parts}
										columns={this.state.partsColumns}
									/>
								</div>
							</AccordionDetails>
						</Accordion>
					</CardContent>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
    return {
		isExtranetApp: state.context.isExtranetApp,
    };
};

const mapDispatchToProps = () => {
	return {};
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(WorkOrderCard);
